import React, {useEffect} from 'react';
import {Stack, FormControlLabel, Checkbox, IconButton} from '@mui/material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import {FileTag, UsedFileTag} from '@pages/FilesPage';
import {ButtonWithConfirm} from '@ui/ButtonWithConfirm/ButtonWithConfirm';
import {useTranslation} from 'react-i18next';

type TagListRowProps = {
    tag: FileTag;
    checked: boolean;
    onToggle: (tag: FileTag) => void;
    onDeleteClick: (tag: FileTag) => void;
    onDeleteConfirm: (tag: FileTag) => void;
    usedTag: UsedFileTag; // Нужно, чтобы отобразить кол-во привязанных документов перед удалением
};

export const TagListRow = ({
    tag,
    checked,
    onToggle,
    onDeleteClick,
    onDeleteConfirm,
    usedTag,
}: TagListRowProps) => {
    const {t} = useTranslation('supervising');

    useEffect(() => {
        onDeleteClick(tag);
    }, [tag, onDeleteClick]);
    return (
        <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
        >
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={() => onToggle(tag)}
                        size='small'
                        sx={{p: 0.4}}
                    />
                }
                label={tag.title}
            />
            <Stack
                direction='row'
                spacing={0.5}
            >
                {/* TODO решили пока напрямую не редактировать
          <IconButton size='small'>
            <EditIcon fontSize='small' />
          </IconButton>
          */}
                {usedTag.isUsed ? (
                    <ButtonWithConfirm
                        icon={
                            <DeleteOutlinedIcon
                                color='action'
                                sx={{opacity: 0.56}}
                            />
                        }
                        onConfirm={() => onDeleteConfirm(tag)}
                        title={`${t('tagListRow.sureDeleteTag')} «${tag.title}»? ${t('tagListRow.nowLinked')}.`}
                    />
                ) : (
                    <IconButton onClick={() => onDeleteConfirm(tag)}>
                        <DeleteOutlinedIcon
                            color='action'
                            sx={{opacity: 0.56}}
                        />
                    </IconButton>
                )}
            </Stack>
        </Stack>
    );
};
